// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1B1Ax","content":"styles_content__kVKOy","checkbox":"styles_checkbox__1_ZQf","checkboxLabel":"styles_checkboxLabel__L4Pka"};